export default __webpack_public_path__ + "static/media/range1.dbb8e027.png";